// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, recordOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

const emailTemplateValidationObject = objectOf({
  id: string,
  name: string,
  description: string,
  subject: string,
  template: string,
  email_amp_body: maybe(string),
  plaintext_body: maybe(string),
  dnd_template_json: string,
  is_dnd_template: boolean,
  preheader: string,
  should_whitespace_preheader: boolean,
  should_inline_css: boolean,
  attached_images: maybe(
    arrayOf(
      objectOf({
        app_group_id: maybe(string),
        id: string,
        name: string,
        url: string,
        ext: string,
        created_at: number,
        created_by: maybe(string),
        size: maybe(number),
        known_width: maybe(number),
        known_height: maybe(number),
        progress: maybe(number),
        error: maybe(string),
        warning: maybe(string),
        last_edited_by: maybe(string),
        ratio: arrayOf(maybe(number)),
        territory_ids: arrayOf(maybe(string)),
        type: maybe(string),
      })
    )
  ),
  tag_names: arrayOf(maybe(string)),
  territory_ids: arrayOf(maybe(string)),
  api_identifier: string,
  created_at: number,
  last_edited: number,
  spam_test_id: maybe(number),
  spam_test_start_time: maybe(number),
  email_test_id: maybe(number),
  email_test_start_time: maybe(number),
  accessibility_test_id: maybe(number),
  accessibility_test_start_time: maybe(number),
  marked_as_deleted: boolean,
  email_headers: maybe(recordOf({ key: string, value: string })),
  email_extras: maybe(recordOf({ key: string, value: string })),
  created_by: string,
  last_edited_by: string,
});

export const isPostEngagementEmailTemplatesIdResponse = objectOf({
  info: string,
  template: emailTemplateValidationObject,
});

export const isEngagementEmailTemplatesIdResult = emailTemplateValidationObject;
